import { loadStripe, Stripe } from "@stripe/stripe-js";

export class StripePurchase {
  private stripe: Stripe | null = null;

  constructor() {
    this.init();
  }

  async init() {
    console.log("Initializing StripePurchase");
    if ($("#purchase_form").length !== 0) {
      this.stripe = await loadStripe(process.env.STRIPE_PUBLIC_KEY);
      this.setupPurchaseForm();
    }
  }

  setupPurchaseForm() {
    console.log("Setting up purchase form");
    const form = $("#purchase_form");

    form.on("submit", async (e) => {
      e.preventDefault();

      const submitButton = form.find('button[type="submit"]');
      submitButton.prop("disabled", true);
      submitButton.find(".c-button__inner").text("処理中...");

      const formData = new FormData(form[0] as HTMLFormElement);
      const creditCardId = formData.get("credit_card[credit_card_id]");

      if (!creditCardId) {
        this.showError("クレジットカードを選択してください");
        this.resetButton(submitButton);
        return;
      }

      try {
        const response = await fetch(form.attr("action"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") || "",
            Accept: "application/json",
          },
          body: JSON.stringify({
            credit_card: { credit_card_id: creditCardId },
          }),
        });

        const data = await response.json();
        console.log("Purchase response data:", data);

        if (data.requires_action && data.client_secret) {
          await this.handle3DSecure(
            data.client_secret,
            data.payment_intent_id,
            creditCardId as string,
          );
        } else if (data.success && data.redirect_url) {
          window.location.href = data.redirect_url;
        } else if (data.error) {
          this.showError(data.error);
          this.resetButton(submitButton);
        }
      } catch (error) {
        console.error("Purchase error:", error);
        this.showError("決済処理中にエラーが発生しました");
        this.resetButton(submitButton);
      }
    });
  }

  async handle3DSecure(
    clientSecret: string,
    paymentIntentId: string,
    creditCardId: string,
  ) {
    if (!this.stripe) {
      this.showError("Stripeの初期化に失敗しました");
      return;
    }

    const { error, paymentIntent } =
      await this.stripe.confirmCardPayment(clientSecret);

    if (error) {
      this.showError(error.message || "3Dセキュア認証に失敗しました");
      this.resetButton($('#purchase_form button[type="submit"]'));
      return;
    }

    if (paymentIntent && paymentIntent.status === "succeeded") {
      await this.confirmPurchase(paymentIntentId, creditCardId);
    } else {
      this.showError("決済処理に失敗しました");
      this.resetButton($('#purchase_form button[type="submit"]'));
    }
  }

  async confirmPurchase(paymentIntentId: string, creditCardId: string) {
    const form = $("#purchase_form");
    const confirmUrl = form.data("confirm-url");

    try {
      const response = await fetch(confirmUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") || "",
          Accept: "application/json",
        },
        body: JSON.stringify({
          payment_intent_id: paymentIntentId,
          credit_card: { credit_card_id: creditCardId },
        }),
      });

      const data = await response.json();

      if (data.success && data.redirect_url) {
        window.location.href = data.redirect_url;
      } else if (data.error) {
        this.showError(data.error);
        this.resetButton($('#purchase_form button[type="submit"]'));
      }
    } catch (error) {
      console.error("Confirm error:", error);
      this.showError("購入確認中にエラーが発生しました");
      this.resetButton($('#purchase_form button[type="submit"]'));
    }
  }

  showError(message: string) {
    let errorContainer = $(".c-formApiError");
    if (errorContainer.length === 0) {
      errorContainer = $(
        '<div class="c-formApiError"><p class="c-formApiError__text"></p></div>',
      );
      $("#purchase_form").prepend(errorContainer);
    }
    errorContainer.find(".c-formApiError__text").text(message);
    errorContainer.show();
  }

  resetButton(button: JQuery) {
    button.prop("disabled", false);
    button.find(".c-button__inner").text("購入する");
  }
}
